import { call, put, takeEvery } from 'redux-saga/effects';
import { apiWithUrlParams } from '../apiMiddleware/apiMiddleware';
import * as types from '../constants';

function* getLeafCompetition(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    oldestFirst: action.oldestFirst,
    noFavStar: action.noFavStar,
  };
  try {
    const { noFavStar } = action;
    const { data } = yield call(apiWithUrlParams, 'widgets', 'getLeafCompetition', urlParams);
    yield put({
      type: types.GET_LEAF_COMPETITION_SUCCESS, data, noFavStar, widgetId: action.widgetId,
    });
  } catch (error) {
    yield put({ type: types.GET_LEAF_COMPETITION_ERROR, error });
  }
}

function* getLeafEvent(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    matchId: action.matchId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'widgets', 'getLeafEvent', urlParams);
    yield put({ type: types.GET_LEAF_EVENT_SUCCESS, data, widgetId: action.widgetId });
  } catch (error) {
    yield put({ type: types.GET_LEAF_EVENT_ERROR, error });
  }
}

function* getLeafSport(action) {
  const urlParams = {
    id: action.id,
    date: 'today',
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'hublive', 'getCompetitionsList', urlParams);
    yield put({ type: types.GET_LEAF_SPORT_SUCCESS, data, widgetId: action.widgetId });
  } catch (error) {
    yield put({ type: types.GET_LEAF_SPORT_ERROR, error });
  }
}


function* getNextMatch(action) {
  const urlParams = {
    sportId: action.sportId,
    teamId: action.teamId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'widgets', 'getNextMatch', urlParams);
    yield put({ type: types.GET_NEXT_MATCH_SUCCESS, data, widgetId: action.widgetId });
  } catch (error) {
    yield put({ type: types.GET_NEXT_MATCH_ERROR, error });
  }
}

function* watchGetLeafEvent() {
  yield takeEvery(types.GET_LEAF_EVENT_REQUEST, getLeafEvent);
}

function* watchGetLeafCompetition() {
  yield takeEvery(types.GET_LEAF_COMPETITION_REQUEST, getLeafCompetition);
}

function* watchGetLeafSport() {
  yield takeEvery(types.GET_LEAF_SPORT_REQUEST, getLeafSport);
}

function* watchGetNextMatch() {
  yield takeEvery(types.GET_NEXT_MATCH_REQUEST, getNextMatch);
}

export default [
  watchGetLeafEvent,
  watchGetLeafCompetition,
  watchGetLeafSport,
  watchGetNextMatch,
];




// WEBPACK FOOTER //
// ./src/sagas/sports.js